import { Toast } from 'mint-ui';
import 'mint-ui/lib/toast/style.css';
import './style.less';

export default {
  show(message, options = {}) {
    Toast({
      message,
      duration: 2000,
      ...options,
    });
  },

  showError(error, options) {
    if (typeof error === 'string') {
      this.show(error, options);
    }
    if (error && error.type !== 'no_show' && error.message) {
      this.show(error.message, options);
    }
  },
};
